import React from "react"
import { Container } from "reactstrap"

export default function PageHeading({ Heading, BgImg, VidBG, customClass }) {
  return (
    <>
      <div
        className={`${customClass} page-heading`}
        style={{ backgroundImage: `url(${BgImg})` }}
      >
        <Container>
          <h2
            className="section-title text-uppercase mb-5 font-italic text-center text-white"
            dangerouslySetInnerHTML={{
              __html: Heading,
            }}
          />
          {BgImg !== "" ? (
            <video
              className="video-bg"
              playsinline="playsinline"
              autoplay="autoplay"
              loop
              muted
            >
              <source src={VidBG} type="video/mp4" />
            </video>
          ) : null}
        </Container>
      </div>
    </>
  )
}
